/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unicorn/consistent-function-scoping */
import LoadingButton from "@mui/lab/LoadingButton/LoadingButton";
import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box/Box";
import Typography from "@mui/material/Typography/Typography";
import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAuth, setAuthAzureAD } from "../../../store/auth/slice";
import { setAuthTokenAzureAD } from "../../../store/authToken/slice";
import {
  setProfile,
  setProfilePictureBase64,
  setProfileRole,
} from "../../../store/profile/slice";
import { parseDataAzureAD, redirectToAzureAd } from "../../../utils/azure-ad";
import {
  GetAccountData,
  fetchAndDisplayProfileImage,
  getProfile,
  getProfileApiHc,
} from "../../../api/Identity/RemoteRepository";
import { getRoleList } from "../../../api/Role/Repository";
import { RoleEntity } from "../../../api/Role/Entity/RoleEntity";
import { UserInterfaceState } from "../../Enum";
import { useNavigate } from "react-router-dom";
import LoadingBackdrop from "../LoadingBackdrop";
import useModal from "../../Hooks/use-modal";

export function LoginContent({
  buttonText = "Login",
}: {
  buttonText?: string;
}) {
  const [uiState, setUiState] = useState(UserInterfaceState.Idle);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showModal } = useModal();

  useEffect(() => {
    if (window.location.hash.includes("access_token")) {
      setUiState(UserInterfaceState.Loading);
      const adState = parseDataAzureAD(window.location.hash);
      if (!adState._success) return;

      dispatch(setAuthTokenAzureAD(adState.access_token));
      dispatch(setAuthAzureAD(jwtDecode(adState.access_token as string)));

      const fetchMsGraphData = async () => {
        try {
          const getAccountData = await GetAccountData(adState.access_token);

          const getProfileImageBase64 = await fetchAndDisplayProfileImage(
            adState.access_token
          );
          dispatch(setProfilePictureBase64(getProfileImageBase64));
          if (getAccountData.mail.includes("binus.edu")) {
            const dataApiHc = await getProfileApiHc(
              getAccountData.onPremisesExtensionAttributes.extensionAttribute10
            );

            const personData = JSON.parse(dataApiHc).data;

            const position = personData?.position;
            const supervisoryOrganization = personData?.supervisoryOrganization;

            const binusianId = JSON.stringify(personData?.binusianID).replace(
              /"/g,
              ""
            );
            const binusianName = JSON.stringify(personData?.legalName).replace(
              /"/g,
              ""
            );
            const email = JSON.stringify(personData?.workEmail).replace(
              /"/g,
              ""
            );
            const businessUnit =
              supervisoryOrganization?.buDivisionText.replace(/"/g, "");
            const title = JSON.stringify(position?.text).replace(/"/g, "");
            const department =
              supervisoryOrganization?.departmentText == undefined
                ? JSON.stringify(
                    supervisoryOrganization?.subBuDivisionText
                  ).replace(/"/g, "")
                : JSON.stringify(
                    supervisoryOrganization?.departmentText
                  ).replace(/"/g, "");

            const profileData = await getProfile({
              binusianId,
              binusianName,
              businessUnit,
              department,
              email,
              title,
            });

            const roleList = await getRoleList();
            const roleMap: Record<string, RoleEntity> = {};
            roleList.forEach((role) => {
              roleMap[role.id] = role;
            });
            if (profileData.isActive) {
              dispatch(setProfileRole(roleMap[profileData.roleId]));
              dispatch(setProfile(profileData));
              dispatch(setAuth(profileData));
            } else {
              showModal({
                title: "Login Failed",
                message:
                  "Your account has been deactivated, please contact your administrator.",
                options: {
                  variant: "failed",
                },
              });
            }
            navigate("/");
            setUiState(UserInterfaceState.Success);
          } else {
            setUiState(UserInterfaceState.Error);
            showModal({
              title: "Login Failed",
              message:
                "User account not found, Email does not contain binus.edu",
              options: {
                variant: "failed",
              },
            });
            navigate("/");
          }
        } catch (error) {
          setUiState(UserInterfaceState.Error);
          console.log("Error fetching data:", error);
        }
      };

      fetchMsGraphData();
    }
  }, []);

  return (
    <Box>
      <LoadingButton
        variant="contained"
        color="secondary"
        loadingIndicator={
          <CircularProgress sx={{ color: "#5E5E5E" }} size="20px" />
        }
        className="h-[41px] text-none rounded-[6px] flex gap-[12px] text-[#5E5E5E] relative top-0 left-1/2 md:left-0 transform md:transform-none translate-x-[-50%] md:translate-x-0 px-6"
        onClick={() => {
          setUiState(UserInterfaceState.Loading);
          redirectToAzureAd({
            prompt: "select_account",
            state: { continue: "" },
          });
        }}
        loading={UserInterfaceState.isLoading(uiState)}
        disabled={UserInterfaceState.isLoading(uiState)}
      >
        <Box
          component="img"
          src="/assets/icon/ic_microsoft.png"
          sx={
            UserInterfaceState.isLoading(uiState)
              ? { display: "none" }
              : { display: "block" }
          }
        />
        <Typography
          sx={
            UserInterfaceState.isLoading(uiState)
              ? { display: "none" }
              : { display: "block" }
          }
          className="normal-case text-sm font-semibold"
        >
          {buttonText}
        </Typography>
      </LoadingButton>
      <LoadingBackdrop isOpen={UserInterfaceState.isLoading(uiState)} />
    </Box>
  );
}
